/* eslint-disable */

const idMap = "map-eco-center";
//Функция создания карты сайта и затем вставки ее в блок с идентификатором &#34;map-yandex&#34;
function init() {
  var myMapTemp = new ymaps.Map(idMap, {
    center: [68.12567307790675,93.6056745429687], // координаты центра на карте
    zoom: ($(window).width() < 640 ? 2 : 3), // коэффициент приближения карты
    controls: [] // выбираем только те функции, которые необходимы при использовании
  }),
    ZoomLayout = ymaps.templateLayoutFactory.createClass("<div class='map-controls'><span class='crow'></span><div id='zoom-in' class='zoom-in'><span class='icon-plus'>+</span></div><div id='zoom-out' class='zoom-out'><span class='icon-minus'>-</span></div></div>", {
      build: function () {
        ZoomLayout.superclass.build.call(this), this.zoomInCallback = ymaps.util.bind(this.zoomIn, this), this.zoomOutCallback = ymaps.util.bind(this.zoomOut, this), $("#zoom-in").bind("click", this.zoomInCallback), $("#zoom-out").bind("click", this.zoomOutCallback)
      },
      clear: function () {
        $("#zoom-in").unbind("click", this.zoomInCallback), $("#zoom-out").unbind("click", this.zoomOutCallback), ZoomLayout.superclass.clear.call(this)
      },
      zoomIn: function () {
        var e = this.getData().control.getMap();
        e.setZoom(e.getZoom() + 1, {
          checkZoomRange: !0
        })
      },
      zoomOut: function () {
        var e = this.getData().control.getMap();
        e.setZoom(e.getZoom() - 1, {
          checkZoomRange: !0
        })
      }
    }),
    zoomControl = new ymaps.control.ZoomControl({
      options: {
        layout: ZoomLayout
      }
    });

  myMapTemp.controls.add(zoomControl, {
    float: "none",
    position: {
      bottom: 100,
      right: 15
    }
  });
  myMapTemp.behaviors.disable("scrollZoom");
    
  
  var objectManager = new ymaps.ObjectManager();
  

  // Создаём макет метки
  const MyIconContentLayout = ymaps.templateLayoutFactory.createClass(
      '<div class="placemark_layout_container">$[properties.iconContent]</div>'
  );
  const MyIconContentLayoutOpen = ymaps.templateLayoutFactory.createClass(
      '<div class="placemark_layout_container active">$[properties.iconContent]</div>'
  );
  // задаем стили для меток
  objectManager.objects.options.set('iconLayout', MyIconContentLayout);
  objectManager.objects.options.set('iconShape', {
      type: 'Circle',
      // Круг описывается в виде центра и радиуса
      coordinates: [22, 22],
      radius: 22
  });
  objectManager.objects.options.set('hideIconOnBalloonOpen', false);


  // Создание макета балуна на основе Twitter Bootstrap.
  var MyBalloonLayout = ymaps.templateLayoutFactory.createClass(
    '<div class="popover top">' +
      '<a class="close" href="#">&times;</a>' +
      '<div class="arrow"></div>' +
      '<div class="popover-inner">' +
      '$[[options.contentLayout ]]' +
      '</div>' +
      '</div>', {
      /**
       * Строит экземпляр макета на основе шаблона и добавляет его в родительский HTML-элемент.
       * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/layout.templateBased.Base.xml#build
       * @function
       * @name build
       */
      build: function () {
          this.constructor.superclass.build.call(this);

          this._$element = $('.popover', this.getParentElement());

          this.applyElementOffset();

          this._$element.find('.close')
              .on('click', $.proxy(this.onCloseClick, this));
      },

      /**
       * Удаляет содержимое макета из DOM.
       * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/layout.templateBased.Base.xml#clear
       * @function
       * @name clear
       */
      clear: function () {
          this._$element.find('.close')
              .off('click');

          this.constructor.superclass.clear.call(this);
      },

      /**
       * Метод будет вызван системой шаблонов АПИ при изменении размеров вложенного макета.
       * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/IBalloonLayout.xml#event-userclose
       * @function
       * @name onSublayoutSizeChange
       */
      onSublayoutSizeChange: function () {
          MyBalloonLayout.superclass.onSublayoutSizeChange.apply(this, arguments);

          if(!this._isElement(this._$element)) {
              return;
          }

          this.applyElementOffset();

          this.events.fire('shapechange');
      },

      /**
       * Сдвигаем балун, чтобы "хвостик" указывал на точку привязки.
       * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/IBalloonLayout.xml#event-userclose
       * @function
       * @name applyElementOffset
       */
      applyElementOffset: function () {
          this._$element.css({
              left: ($(window).width() < 640 ? -(this._$element[0].offsetWidth / 2) + 22 : 70),
              top: ($(window).width() < 640 ? -50 : -(this._$element[0].offsetHeight / 2) + 22)
          });
      },

      /**
       * Закрывает балун при клике на крестик, кидая событие "userclose" на макете.
       * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/IBalloonLayout.xml#event-userclose
       * @function
       * @name onCloseClick
       */
      onCloseClick: function (e) {
          e.preventDefault();

          this.events.fire('userclose');
      },

      /**
       * Используется для автопозиционирования (balloonAutoPan).
       * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/ILayout.xml#getClientBounds
       * @function
       * @name getClientBounds
       * @returns {Number[][]} Координаты левого верхнего и правого нижнего углов шаблона относительно точки привязки.
       */
      getShape: function () {
          if(!this._isElement(this._$element)) {
              return MyBalloonLayout.superclass.getShape.call(this);
          }

          var position = this._$element.position();

          return new ymaps.shape.Rectangle(new ymaps.geometry.pixel.Rectangle([
              [position.left, position.top], [
                  position.left + ($(window).width() < 640 ? this._$element[0].offsetWidth : this._$element[0].offsetWidth + 50),
                  position.top + ($(window).width() < 640 ? this._$element[0].offsetHeight + 40 : this._$element[0].offsetHeight) 
              ]
          ]));
      },

      /**
       * Проверяем наличие элемента (в ИЕ и Опере его еще может не быть).
       * @function
       * @private
       * @name _isElement
       * @param {jQuery} [element] Элемент.
       * @returns {Boolean} Флаг наличия.
       */
      _isElement: function (element) {
          return element && element[0] && element.find('.arrow')[0];
      }
  });
  objectManager.objects.options.set('balloonLayout', MyBalloonLayout);

  // Создание вложенного макета содержимого балуна.
  var MyBalloonContentLayout = ymaps.templateLayoutFactory.createClass(
      '$[properties.balloonContent]'
  );
  objectManager.objects.options.set('balloonContentLayout', MyBalloonContentLayout);


  objectManager.events.add(['balloonopen'], function (e) {
    console.log(e.get('target')._captor._data.object.properties.region);
    $(`.eco-center-events__card`).addClass('js-target-el');
    $(`.eco-center-events__card`).attr('hidden', '');
    $('.eco-center-events__bottom').hide();
    [...document.querySelectorAll(`.eco-center-events__card[data-region="${e.get('target')._captor._data.object.properties.region}"]`)].forEach(el => {
      $(el).removeAttr('hidden');
      $(el).removeClass('js-target-el');
    })
    // console.log($(`.eco-center-events__card[data-region="${e.get('target')._captor._data.object.properties.region}"]`));
    objectManager.objects.setObjectOptions(e.get('objectId'), {
      iconLayout: MyIconContentLayoutOpen
    });
  });
  objectManager.events.add(['balloonclose'], function (e) {
    $(`.eco-center-events__card`).removeClass('js-target-el');
    $(`.eco-center-events__card`).removeAttr('hidden');
    objectManager.objects.setObjectOptions(e.get('objectId'), {
      iconLayout: MyIconContentLayout
    });
  });

  // добавляем коллекцию на карту 
  objectManager.add(collection);
  myMapTemp.geoObjects.add(objectManager);

  // $.ajax({
  //     // В файле data.json заданы геометрия, опции и данные меток .
  //     url: "data.json"
  // }).done(function(data) {
  //     objectManager.add(data);
  // });
  
  

  if ($(window).width() < 640) {
    var mapEve = myMapTemp.panes.get("events");
    var mapElem = mapEve.getElement();
    myMapTemp.behaviors.disable('drag');
    ymaps.domEvent.manager.add(mapElem, "touchmove", function (e) {
      1 === e.get("touches").length && (mapElem.style.transition = "opacity .3s",
        mapElem.style.background = "rgba(0, 0, 0, .45)",
        mapElem.style.alignItems = "center",
        mapElem.style.boxSizing = "border-box",
        mapElem.style.color = "white",
        mapElem.style.display = "flex",
        mapElem.style.justifyContent = "center",
        mapElem.style.fontSize = "16px",
        mapElem.style.opacity = "0.0",
        mapElem.style.padding = "25px",
        mapElem.style.textAlign = "center",
        mapElem.style.transition = "opacity .3s",
        mapElem.style.touchAction = "auto",
        mapElem.textContent = 'Чтобы переместить карту проведите по ней двумя пальцами',
        mapElem.style.opacity = "1")
    });
    ymaps.domEvent.manager.add(mapElem, "touchend", function () {
      mapElem.style.transition = "opacity .8s",
        mapElem.style.opacity = "0"
    });
  }

}

// Основная функция, которая проверяет когда мы навели на блок с классом &#34;ymap-container&#34;
export const ymap = function () {
  init();
}